/**
 * Demo page for CodeDiffViewer component
 * Access at: /demo/code-diff
 */

import React from 'react';
import { CodeDiffViewer } from '../../components/shared/CodeDiffViewer';
import './CodeDiffDemo.css';

// Sample git diff output
const SAMPLE_DIFF = `diff --git a/frontend/src/pages/TicketsPage/TicketsPage.js b/frontend/src/pages/TicketsPage/TicketsPage.js
index 1234567..abcdefg 100644
--- a/frontend/src/pages/TicketsPage/TicketsPage.js
+++ b/frontend/src/pages/TicketsPage/TicketsPage.js
@@ -39,6 +39,7 @@ const TicketsPage = () => {
   const { projectId } = useParams();
   const navigate = useNavigate();
   const { searchQuery, setSearchQuery } = useTicketsSearch();
+  const [isSearchFocused, setIsSearchFocused] = useState(false);
   // Use shared tickets context - single source of truth
   const { 
     tickets, 
@@ -48,6 +49,9 @@ const TicketsPage = () => {
   } = useTicketsData();
   const [filterStatus, setFilterStatus] = useState('all');
   const [collapsedSprints, setCollapsedSprints] = useState({});
+  
+  // Computed: expand search when focused OR has text
+  const isSearchExpanded = isSearchFocused || (searchQuery && searchQuery.length > 0);

   useEffect(() => {
     // Load tickets on mount if not already loaded
@@ -198,8 +202,10 @@ const TicketsPage = () => {
               </button>
             </div>
-            <div className="tickets-search">
+            <div className={\`tickets-search \${isSearchExpanded ? 'expanded' : 'compact'}\`}>
               <IonSearchbar
                 placeholder="Search tickets..."
                 value={searchQuery || ''}
                 onIonInput={(e) => setSearchQuery(e.detail.value)}
+                onIonFocus={() => setIsSearchFocused(true)}
+                onIonBlur={() => setIsSearchFocused(false)}
                 debounce={300}
                 className="tickets-page-searchbar"
               />
diff --git a/frontend/src/pages/TicketsPage/TicketsPage.css b/frontend/src/pages/TicketsPage/TicketsPage.css
index 9876543..fedcba9 100644
--- a/frontend/src/pages/TicketsPage/TicketsPage.css
+++ b/frontend/src/pages/TicketsPage/TicketsPage.css
@@ -45,6 +45,22 @@
   flex: 1;
 }

+/* Animated search bar */
+.tickets-search {
+  max-width: 180px;
+  transition: max-width 0.25s ease-out;
+  overflow: hidden;
+}
+
+.tickets-search.compact {
+  max-width: 180px;
+}
+
+.tickets-search.expanded {
+  max-width: 400px;
+}
+
 .tickets-page-searchbar {
-  min-width: 300px;
+  width: 100%;
+  min-width: 0;
   --background: rgba(var(--ion-color-medium-rgb), 0.15);
   --border-radius: 8px;
`;

const CodeDiffDemo = () => {
  return (
    <div className="code-diff-demo-page">
      <div className="demo-header">
        <h1>CodeDiffViewer Component Demo</h1>
        <p className="demo-subtitle">
          Git diff viewer with syntax highlighting and side-by-side view
        </p>
      </div>

      <div className="demo-content">
        <CodeDiffViewer
          diff={SAMPLE_DIFF}
          title="SCRUM-277: Animated search bar expansion"
          showFileList={true}
          showViewToggle={true}
          defaultView="side-by-side"
          defaultCollapsed={false}
        />
      </div>

      <div className="demo-info">
        <h4>Component Props</h4>
        <table>
          <thead>
            <tr>
              <th>Prop</th>
              <th>Type</th>
              <th>Default</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>diff</code></td>
              <td>String</td>
              <td>-</td>
              <td>Git diff output (unified format)</td>
            </tr>
            <tr>
              <td><code>title</code></td>
              <td>String</td>
              <td>null</td>
              <td>Optional title for the diff viewer</td>
            </tr>
            <tr>
              <td><code>defaultView</code></td>
              <td>'side-by-side' | 'line-by-line'</td>
              <td>'side-by-side'</td>
              <td>Initial view mode</td>
            </tr>
            <tr>
              <td><code>showFileList</code></td>
              <td>Boolean</td>
              <td>true</td>
              <td>Show list of changed files at top</td>
            </tr>
            <tr>
              <td><code>showViewToggle</code></td>
              <td>Boolean</td>
              <td>true</td>
              <td>Show view mode toggle buttons</td>
            </tr>
            <tr>
              <td><code>fileContents</code></td>
              <td>Object</td>
              <td>{'{}'}</td>
              <td>Full file contents for expand functionality</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CodeDiffDemo;
